import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  main: {
    paddingBottom: theme.spacing(2),
  },
  filterButtonContainer: {
    paddingTop: theme.spacing(2),
  },
  filterButton: {
    padding: theme.spacing(1),
    '& .MuiTypography-button': {
      display: 'flex',
    },
    float: 'right',
  },
  filterButtonText: {
    color: theme.palette.primary.main,
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'flex',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  filterDrawer: {
    width: theme.spacing(50),
  },
  filterDrawerDiv: {
    padding: theme.spacing(3),
    width: theme.spacing(50),
  },
  closeIcon: {
    float: 'right',
    cursor: 'pointer',
    display: 'inline-block',
  },
  filterTypography: {
    display: 'inline-block',
  },
  pageTitle: {
    paddingTop: theme.spacing(3),
    fontSize: '1.5rem',
    fontWeight: 600,
    font: 'inter',
    alignSelf: 'center',
  },
  activeFiltersIcon: {
    float: 'right',
  },
  filterIcon: {
    float: 'left',
  },
  circle: {
    borderRadius: '8px',
    textAlign: 'center',
    height: '16px',
    width: '16px',
    alignSelf: 'center',
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.primary.dark,
    color: 'white',
    fontWeight: 500,
  },
}));

export default useStyles;
